import { render, staticRenderFns } from "./Notificationmodal.vue?vue&type=template&id=5474437e&scoped=true&"
import script from "./Notificationmodal.vue?vue&type=script&lang=js&"
export * from "./Notificationmodal.vue?vue&type=script&lang=js&"
import style0 from "./Notificationmodal.vue?vue&type=style&index=0&id=5474437e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474437e",
  null
  
)

export default component.exports